var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thumbs"},[_c('div',{staticClass:"items"},[_c('div',{staticClass:"heading"},[_vm._v(_vm._s(_vm.groups && _vm.heading))]),_vm._l((_vm.groups),function(group){return _c('div',{staticClass:"item"},[_c('div',{staticClass:"slides"},_vm._l((group),function(ref,index){
var t = ref.t;
var url = ref.th.url;
return _c('div',{staticClass:"slide",style:({ 'background-image': ("url('" + url + "')") }),attrs:{"title":t}})}),0)])})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }